module.exports = __webpack_public_path__ + "img/products_big_can_ultimateusa.1122ea19.png";